import angular from 'angular';
import pageComponent from './page.component';

import pageConfig from './page.config';

let pageModule = angular.module('app.page',[])
  .component('page', pageComponent)
  .config(pageConfig);

export default pageModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/page/page.js
 **/